import { Link } from "react-router";
import type { SignalListItem } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { StatusChip } from "@/components/StatusChip";
import { MoneyDelta, PipsDelta } from "@/components/MoneyDelta";
import { formatRelative } from "@/lib/format";

export function SignalCard({ signal }: { signal: SignalListItem }) {
  const symbol = signal.brokerSymbol ?? signal.symbol ?? signal.symbolRaw;
  const direction = signal.direction;

  return (
    // The Link must be a block: an inline anchor swallows the vertical margins the
    // parent's space-y-2 puts on it, and the cards render flush against each other.
    <Link to={`/signals/${signal.id}`} className="block">
      <Card className="transition-colors active:bg-accent">
        <CardContent className="flex items-center justify-between gap-3 p-4">
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <span className="truncate text-sm font-semibold">{signal.channelTitle}</span>
              {signal.directionCorrected && (
                <span className="shrink-0 text-xs text-yellow-500" title="Direction was corrected from geometry">
                  corrected
                </span>
              )}
            </div>
            <div className="mt-1 flex items-center gap-2 text-sm">
              {direction && (
                <span className={direction === "buy" ? "text-success" : "text-destructive"}>
                  {direction === "buy" ? "BUY" : "SELL"}
                </span>
              )}
              <span className="font-mono text-muted-foreground">{symbol}</span>
            </div>
            <div className="mt-1 text-xs text-muted-foreground">{formatRelative(signal.createdAt)}</div>
          </div>
          <div className="flex shrink-0 flex-col items-end gap-1.5">
            <StatusChip status={signal.status} />
            {signal.status === "closed" ? (
              <div className="flex flex-col items-end text-xs">
                <MoneyDelta value={signal.profitMoney} />
                <PipsDelta value={signal.pipsRealized} />
              </div>
            ) : (
              signal.skipReason && <span className="max-w-[10rem] truncate text-xs text-muted-foreground">{signal.skipReason}</span>
            )}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
